import { render, staticRenderFns } from "./SaveForNextTimePage.vue?vue&type=template&id=6045d3c0"
import script from "./SaveForNextTimePage.vue?vue&type=script&lang=ts"
export * from "./SaveForNextTimePage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports